<template>
  <v-dialog
    max-width="1200"
    transition="dialog-bottom-transition"
    v-model="showDialog"
    @input="closeDialog"
  >
    <v-card v-bind:loading="loading">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Operation Details</v-toolbar-title>
      </v-toolbar>
      <br />
      <div class="text-center">
        <v-progress-circular
          v-if="!getShowcaseOperation"
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-card-text v-if="getShowcaseOperation">
        <v-row no-gutters>
          <v-col cols="5">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>
                    <span style="color:grey">Operation Name</span>
                  </td>
                  <td>{{ this.getShowcaseOperation.name }}</td>
                </tr>
                <tr>
                  <td>
                    <span style="color:grey">Operation Id</span>
                  </td>
                  <td>{{ this.getShowcaseOperation.operationId }}</td>
                </tr>
                <tr>
                  <td>
                    <span style="color:grey">Status</span>
                  </td>
                  <td>
                    <v-icon
                      small
                      :color="mapStatusColor(getShowcaseOperation.status)"
                      >{{ mapStatusIcon(getShowcaseOperation.status) }}</v-icon
                    >&nbsp;
                    <span :class="mapStatusColor(operation.status) + '--text'"
                      >{{ getShowcaseOperation.status }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-col cols="5">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>
                    <span style="color:grey">Start Date</span>
                  </td>
                  <td>{{ formatDate(getShowcaseOperation.startDate) }}</td>
                </tr>
                <tr>
                  <td>
                    <span style="color:grey">End Date</span>
                  </td>
                  <td>{{ formatDate(getShowcaseOperation.endDate) }}</td>
                </tr>
                <tr>
                  <td>
                    <span style="color:grey">Latest Update</span>
                  </td>
                  <td>{{ formatDate(getShowcaseOperation.latestUpdate) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-title
        v-if="getShowcaseOperation && getShowcaseOperation.parameters"
        >Input</v-card-title
      >
      <v-card-text v-if="getShowcaseOperation">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Key</th>
                <th class="text-left">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="parameter in getShowcaseOperation.parameters"
                :key="parameter.key"
              >
                <td>{{ parameter.key }}</td>
                <td>
                  {{ displayParameterValue(parameter) }}
                  <v-btn
                    icon
                    color="orange"
                    v-if="parameter.type === 'FILE'"
                    @click="downloadInputFile(parameter.value)"
                    small
                    :loading="downloadLoading"
                    ><v-icon>mdi-download</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-title v-if="operation.error">Errors</v-card-title>
      <v-card-text>
        {{ operation.error }}
      </v-card-text>
      <v-card-title>Stages</v-card-title>
      <v-stepper v-model="selectedStage" vertical>
        <template v-for="stage in listShowcaseOperationStages">
          <v-stepper-step
            class="stageHeader"
            :key="stage.operationId"
            :step="stage.position"
            @click="showStep(stage.position)"
            :complete="stage.status === 'SUCCESS'"
            :rules="[() => !(stage.status === 'FAILED')]"
            color="success"
          >
            <span class="stageName">{{ stage.name }}</span>
            <small>Stage {{ stage.position }}</small>
          </v-stepper-step>
          <v-stepper-content :key="stage.position" :step="stage.position">
            <OperationStage
              :stage="stage"
              :showcase="showcase"
            ></OperationStage>
          </v-stepper-content>
        </template>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  GET_OPERATION,
  LIST_SHOWCASE_OPERATION_STAGES,
  ON_UPDATE_OPERATION,
  GENERATE_PRESIGNED_URL,
  ON_UPDATE_OPERATION_STAGE
} from '../../constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import OperationStage from './OperationsStage'
import { formatDate } from '@/domain/showcases/util/timeFormat'
import { mapStatusColor, mapStatusIcon } from '@/domain/showcases/util/status'

export default {
  name: 'OperationDetails',
  components: { OperationStage },
  data: () => ({
    showDialog: true,
    loading: true,
    selectedStage: 0,
    downloadLoading: false,
    getShowcaseOperation: null,
    getShowcaseOperationErrors: null,
    listShowcaseOperationStages: [],
    listShowcaseOperationStagesErrors: null,
    updatedOperationStep: null
  }),
  props: ['operation', 'showcase'],
  apollo: {
    $client: DOMAIN_NAME,
    listShowcaseOperationStages: {
      query: LIST_SHOWCASE_OPERATION_STAGES,
      fetchPolicy: 'network-only',
      variables() {
        return {
          showcaseId: this.showcase.showcaseId,
          operationId: this.operation.operationId
        }
      },
      skip() {
        return !this.showcase
      },
      error(error) {
        this.listShowcaseOperationStagesErrors = JSON.stringify(error.message)
      }
      // subscribeToMore: {
      //   document: ON_UPDATE_OPERATION_STAGE,
      //   // variables() {
      //   //   return {
      //   //     parentOperationId: this.operation.operationId
      //   //   }
      //   // },
      //   updateQuery: (previousResult, { subscriptionData }) => {
      //     console.log(previousResult.listShowcaseOperationStages)
      //     console.log(subscriptionData.data.onUpdateOperationStage)
      //     return previousResult
      //   },
      //   error: error => {
      //     console.log(error)
      //   }
      // }
    },
    getShowcaseOperation: {
      query: GET_OPERATION,
      fetchPolicy: 'network-only',
      variables() {
        return {
          showcaseId: this.showcase.showcaseId,
          operationId: this.operation.operationId
        }
      },
      skip() {
        return !this.showcase
      },
      result() {
        this.loading = false
      },
      error(error) {
        this.listShowcaseOperationStagesErrors = JSON.stringify(error.message)
      },
      subscribeToMore: {
        document: ON_UPDATE_OPERATION,
        variables() {
          return {
            operationId: this.operation.operationId
          }
        },
        updateQuery: (previousResult, { subscriptionData }) => {
          let presentEntries = Object.fromEntries(
            Object.entries(subscriptionData.data.onUpdateOperation).filter(
              ([k, v]) => v != null && k !== 'parameters'
            )
          )
          Object.assign(previousResult.getShowcaseOperation, presentEntries)

          return previousResult
        }
      }
    }
  },
  methods: {
    showStep(position) {
      this.selectedStage = this.selectedStage === position ? 0 : position
    },
    mapStatusIcon: mapStatusIcon,
    mapStatusColor: mapStatusColor,
    formatDate: formatDate,
    displayParameterValue(parameter) {
      if (parameter.type !== 'FILE') {
        return parameter.value
      } else {
        return parameter.value.substring(
          parameter.value.lastIndexOf('/') + 1,
          parameter.value.length
        )
      }
    },
    getPresignedURL: async function(s3Key) {
      return this.$apolloProvider.clients['SHOWCASE']
        .query({
          query: GENERATE_PRESIGNED_URL,
          variables: {
            showcaseId: this.showcase.showcaseId,
            key: s3Key
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          return {
            url: response.data.generatePresignedUrl.url
          }
        })
        .catch()
    },
    downloadInputFile(s3Key) {
      this.downloadLoading = true
      this.getPresignedURL(s3Key).then(result => {
        this.downloadFile(result.url, s3Key)
          .then(() => {
            this.downloadLoading = false
          })
          .catch(err => {
            this.downloadLoading = false
          })
      })
    },
    downloadFile: async function(url, key) {
      await this.axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]))
          let fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            key.substring(key.lastIndexOf('/') + 1, key.length)
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          fileLink.remove()
        })
        .catch(err => {})
    },
    closeDialog() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.stageHeader {
  cursor: pointer;
}
.stageHeader:hover {
  background: #eee;
}
.stageName {
  float: left;
}
</style>
